(function () {
  'use strict';
  function init(root) {
    if (root.dataset.a46Initialized) return;
    var dialog = root.querySelector('[data-a46-alert-dialog]');
    var open = root.querySelector('[data-a46-alert-open]');
    var close = root.querySelector('[data-a46-alert-close]');
    var form = root.querySelector('[data-a46-alert-form]');
    var status = root.querySelector('[data-a46-alert-status]');
    var submit = root.querySelector('[data-a46-alert-submit]');
    var captcha = root.querySelector('[data-a46-alert-turnstile]');
    var variantMode = root.dataset.a46AlertScope === 'variant';
    var variantSelect = root.querySelector('[data-a46-alert-variant-select]');
    var widgetId = null;
    var submitted = false;
    var submitting = false;
    if (!dialog || !open || !close || !form || !status || !submit || !captcha) return;
    root.dataset.a46Initialized = '1';
    var endpoint = (root.dataset.endpoint || '').replace(/\/$/, '');
    var sitekey = root.dataset.turnstileSitekey || '';
    function ensureCaptcha() {
      if (submitted || sitekey.indexOf('REPLACE-') === 0 || !sitekey || widgetId !== null) return;
      if (window.turnstile) {
        widgetId = window.turnstile.render(captcha, { sitekey: sitekey, size: 'flexible' });
      } else {
        window.setTimeout(ensureCaptcha, 150);
      }
    }
    function resetSuccess() {
      if (!submitted) return;
      submitted = false;
      status.classList.remove('a46-alert-success');
      status.removeAttribute('tabindex');
      status.textContent = '';
      form.appendChild(status);
      form.hidden = false;
      dialog.classList.remove('a46-alert-submitted');
    }
    function showSuccess(message) {
      submitted = true;
      var icon = document.createElement('span');
      icon.className = 'a46-alert-success-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '\u2713';
      var title = document.createElement('strong');
      title.className = 'a46-alert-success-title';
      title.textContent = 'Request received';
      var detail = document.createElement('span');
      detail.className = 'a46-alert-success-message';
      detail.textContent = message || 'Your alert request was received.';
      status.textContent = '';
      status.append(icon, title, detail);
      status.classList.add('a46-alert-success');
      status.setAttribute('tabindex', '-1');
      form.insertAdjacentElement('afterend', status);
      form.hidden = true;
      dialog.classList.add('a46-alert-submitted');
      if (window.turnstile && widgetId !== null) {
        try { window.turnstile.remove(widgetId); }
        catch (error) {}
        widgetId = null;
      }
      if (dialog.open) status.focus();
    }
    // In the popup, the selected variant determines which exact product option
    // receives an alert. Product-wide statuses keep their original alert kind.
    function selectedOption() {
      return variantSelect && variantSelect.selectedIndex >= 0
        ? variantSelect.options[variantSelect.selectedIndex] : null;
    }
    function selectVariant(variantId) {
      if (!variantSelect || !variantId) return false;
      for (var i = 0; i < variantSelect.options.length; i += 1) {
        if (variantSelect.options[i].value === String(variantId)) {
          variantSelect.selectedIndex = i;
          return true;
        }
      }
      return false;
    }
    function syncPopupVariant() {
      if (!variantSelect) return;
      var option = selectedOption();
      if (!option) return;
      var id = option.value;
      var kind = variantMode ? (option.dataset.a46Kind || '') : root.dataset.productKind;
      if (!kind) return;
      if (root.dataset.variantId !== id || (variantMode && root.dataset.productKind !== kind)) resetSuccess();
      root.dataset.variantId = id;
      root.dataset.productKind = kind;
      if (variantMode) {
        var description = root.querySelector('[data-a46-variant-description]');
        if (description) description.textContent = kind === 'preorder'
          ? 'Get an email when this selected pre-order option is released for regular purchase.'
          : 'Get an email when this selected backorder option is restocked for regular purchase.';
        var label = root.querySelector('[data-a46-variant-label]');
        if (label) label.textContent = option.textContent;
      }
    }
    if (variantSelect) variantSelect.addEventListener('change', syncPopupVariant);
    // Only option-worded products follow product-page variant events.
    function updateVariantAlert(detail) {
      if (!variantMode || !detail) return;
      var kind = detail.type === 'preorder' || detail.type === 'backorder' ? detail.type : '';
      var variantId = detail.variantId == null ? '' : String(detail.variantId);
      if (!kind || !variantId) {
        root.style.display = 'none';
        root.dataset.productKind = '';
        root.dataset.variantId = '';
        if (dialog.open) dialog.close();
        return;
      }
      if (root.dataset.productKind !== kind || root.dataset.variantId !== variantId) {
        resetSuccess();
        root.dataset.productKind = kind;
        root.dataset.variantId = variantId;
        if (variantSelect) selectVariant(variantId);
        open.textContent = kind === 'preorder' ? 'Notify Me When Released' : 'Notify Me When Restocked';
        var description = root.querySelector('[data-a46-variant-description]');
        if (description) description.textContent = kind === 'preorder'
          ? 'Get an email when this selected pre-order option is released for regular purchase.'
          : 'Get an email when this selected backorder option is restocked for regular purchase.';
        var label = root.querySelector('[data-a46-variant-label]');
        if (label) label.textContent = detail.variantTitle || '';
      }
      root.style.display = '';
    }
    if (variantMode) {
      document.addEventListener('a46:availability-change', function (e) {
        updateVariantAlert(e.detail);
      });
      // The variant-helper may have evaluated the initial variant before init().
      if (window.__AVAILABILITY_STATE__) updateVariantAlert(window.__AVAILABILITY_STATE__);
    }
    open.addEventListener('click', function (e) {
      e.preventDefault();
      if (!submitted) status.textContent = '';
      // On product-level tags, default to the variant currently selected on
      // the product page. Changing the popup dropdown won't add to cart.
      if (!variantMode && variantSelect) {
        var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (field && field.value) selectVariant(field.value);
        syncPopupVariant();
      }
      if (!dialog.open) {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }
      if (submitted) status.focus();
      else ensureCaptcha();
    });
    close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitted || submitting) return;
      if (variantSelect) syncPopupVariant();
      if ((variantMode || variantSelect) && (!root.dataset.variantId || !root.dataset.productKind)) {
        status.textContent = 'Please select an available notification option.';
        return;
      }
      if (endpoint.indexOf('REPLACE-') !== -1 || !/^https:\/\//.test(endpoint)) {
        status.textContent = 'Notification signup is not configured yet.';
        return;
      }
      submitting = true;
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Submitting\u2026';
      var body = {
        email: form.elements.email.value.trim(),
        product_id: root.dataset.productId,
        kind: root.dataset.productKind,
        captcha: (form.querySelector('[name="cf-turnstile-response"]') || {}).value || ''
      };
      if (root.dataset.variantId) body.variant_id = root.dataset.variantId;
      fetch(endpoint + '/subscribe', {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.ok !== true) throw new Error(data.error || 'Unable to subscribe.');
          return data;
        });
      }).then(function (data) {
        form.elements.email.value = '';
        showSuccess(data.message);
      }).catch(function (err) {
        status.textContent = err.message || 'Unable to subscribe. Try again.';
      }).finally(function () {
        submitting = false;
        form.removeAttribute('aria-busy');
        if (!submitted) {
          submit.disabled = false;
          if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId);
        }
      });
    });
  }
  function start() {
    document.querySelectorAll('[data-a46-availability-alert]').forEach(init);
    if (document.querySelector('[data-a46-availability-alert][data-turnstile-sitekey]:not([data-turnstile-sitekey^="REPLACE-"])')) {
      if (!document.querySelector('script[data-a46-turnstile-script]')) {
        var script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true; script.defer = true;
        script.setAttribute('data-a46-turnstile-script', '');
        document.head.appendChild(script);
      }
    }
  }
  // Capture-phase fallback in themes that intercept product-area clicks.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-a46-alert-open]');
    if (!button) return;
    var root = button.closest('[data-a46-availability-alert]');
    if (!root) return;
    if (!root.dataset.a46Initialized) init(root);
    var dialog = root.querySelector('[data-a46-alert-dialog]');
    if (!dialog || dialog.open) return;
    try { dialog.showModal(); }
    catch (error) { console.error('[A46] Unable to open availability dialog:', error); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
